
















































import { Component, Prop, Ref } from 'vue-property-decorator';
import Vue from 'vue';
import { BDropdown } from 'bootstrap-vue';
import { ITask, TaskStatus } from 'admiral-core';
import { CheckIcon, TrashIcon } from 'vue-feather-icons';
import TaskStatusIcon from './TaskStatusIcon.vue';
import { TaskApi } from '@/services/TaskApi';

const STATUS_LABELS: Record<TaskStatus, string> = {
  [TaskStatus.TODO]: 'Offen',
  [TaskStatus.IN_PROGRESS]: 'In Bearbeitung',
  [TaskStatus.IN_WAITING]: 'Warten',
  [TaskStatus.COMPLETED]: 'Erledigt',
  [TaskStatus.ARCHIVED]: 'Archiviert',
};

@Component({
  name: 'TaskStatusMenu',
  components: {
    TaskStatusIcon,
    CheckIcon,
    TrashIcon,
  },
})
export default class TaskStatusMenu extends Vue {
  @Prop({ type: Object, required: true }) task!: ITask;
  @Prop({ type: String, default: 'md' }) iconSize!: 'sm' | 'md' | 'lg';

  @Ref('dropdown') dropdownRef!: BDropdown;

  get statusOptions(): { status: TaskStatus; label: string }[] {
    return Object.values(TaskStatus).map((status) => ({
      status,
      label: STATUS_LABELS[status],
    }));
  }

  hideMenu() {
    this.dropdownRef?.hide();
  }

  onOverlayOpened() {
    const parent = this.$el.closest?.('.todo-item, .task-kanban-item');
    parent?.classList?.add('task-status-dropdown-open');
  }

  onOverlayClosed() {
    const parent = this.$el.closest?.('.todo-item, .task-kanban-item');
    parent?.classList?.remove('task-status-dropdown-open');
  }

  onSelectStatus(newStatus: TaskStatus) {
    this.hideMenu();
    if (this.task.status === newStatus) return;
    this.$emit('status-change', newStatus);
  }

  async onDeleteTask() {
    this.hideMenu();
    try {
      await TaskApi.delete(this.task.id);
      this.$emit('delete-task', this.task);
    } catch (e) {
      this.$toastr.e('Aufgabe konnte nicht gelöscht werden.');
    }
  }
}
